/**
 * Contact form — Alpine component with localStorage persistence + AJAX submit.
 * Extracted from sections/contact-form.liquid.
 *
 * Default field values (the signed-in customer's own details) are passed via
 * data-default-* attributes on the component root.
 */
document.addEventListener('alpine:init', () => {
  Alpine.data('contactForm', () => ({
    name: '',
    email: '',
    phone: '',
    body: '',
    showSuccess: false,
    showError: false,

    init() {
      const d = this.$el.dataset;
      this.name = localStorage.getItem('contact-name') || d.defaultName || '';
      this.email = localStorage.getItem('contact-email') || d.defaultEmail || '';
      this.phone = localStorage.getItem('contact-phone') || d.defaultPhone || '';
      // No server-provided default for the message body; only restore any saved draft.
      this.body = localStorage.getItem('contact-body') || '';

      this.$nextTick(() => {
        const form = document.getElementById('ContactForm');
        if (form) form.addEventListener('submit', (e) => this.submitForm(e));
      });
    },

    updateStorage() {
      localStorage.setItem('contact-name', this.name);
      localStorage.setItem('contact-email', this.email);
      localStorage.setItem('contact-phone', this.phone);
      localStorage.setItem('contact-body', this.body);
    },

    submitForm(e) {
      e.preventDefault();
      e.stopPropagation();
      this.updateStorage();
      const form = e.target;
      const formData = new FormData(form);
      // Ensure formData reflects Alpine state values
      formData.set('contact[name]', this.name);
      formData.set('contact[email]', this.email);
      formData.set('contact[phone]', this.phone);
      formData.set('contact[body]', this.body);
      fetch(form.action, {
        method: 'POST',
        body: formData,
      })
        .then((response) => {
          if (response.ok) {
            this.showSuccess = true;
            this.showError = false;
            // Clear saved data on success
            localStorage.removeItem('contact-name');
            localStorage.removeItem('contact-email');
            localStorage.removeItem('contact-phone');
            localStorage.removeItem('contact-body');
            this.name = '';
            this.email = '';
            this.phone = '';
            this.body = '';
            setTimeout(() => {
              this.showSuccess = false;
            }, 5000);
          } else {
            this.showError = true;
            this.showSuccess = false;
            setTimeout(() => {
              this.showError = false;
            }, 5000);
          }
        })
        .catch(() => {
          this.showError = true;
          this.showSuccess = false;
          setTimeout(() => {
            this.showError = false;
          }, 5000);
        });
    },
  }));
});
